import { t } from '@lingui/core/macro';

import { useSectors } from '@/api/settings';
import {
  CategoryFilter,
  ComboboxPickerFilter,
  encodeFilterFieldName,
  FilterField,
  useFilterForm,
} from '@/components/filters';
import type { FilterOperatorMulti } from '@/components/InstantSearch';
import type { FilterComponentProps } from '@/providers/TableState';

type Props = FilterComponentProps & {
  mode?: 'multiple';
};

const IndustryFilter = ({ name, label, infoPopover, compact, mode = 'multiple' }: Props) => {
  const form = useFilterForm();
  const { sectors, isLoading, error } = useSectors({ includeBlanks: true });

  return (
    <form.AppField name={encodeFilterFieldName(name)}>
      {(field) => (
        <FilterField
          data-testid="industry-filter"
          label={label}
          infoPopover={infoPopover}
          hideLabel={!compact}
        >
          {compact ? (
            <ComboboxPickerFilter
              value={field.state.value as FilterOperatorMulti}
              onChange={field.handleChange}
              mode={mode}
              singlePlaceholder={t`Select Industry...`}
              multiplePlaceholder={t`Select Industries...`}
              multipleLoadingPlaceholder={t`Loading Industries...`}
              items={sectors}
              isLoading={isLoading}
              error={error}
              notFoundContent={t`No industries were found...`}
            />
          ) : (
            <CategoryFilter
              value={field.state.value as FilterOperatorMulti}
              onChange={field.handleChange}
              selectionMode={mode}
              isLoading={isLoading}
              error={error}
              options={sectors}
            />
          )}
        </FilterField>
      )}
    </form.AppField>
  );
};

export default IndustryFilter;
